<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <custom-result-not-found v-if="items.length === 0" />
    <time-line class="mt-4">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <em
              class="radius"
              :class="`fas fa-${getIconStatus(item.statusId)}`"
            />
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.createDate | date }}
              </div>
              <div class="color-black font-12 font-weight-normal hour">
                {{ item.createDate | hour }}
              </div>
            </div>
          </template>
          <div class="row py-4 mx-3">
            <div class="col-md-3 col-sm-12 border-right">
              <div class="color-gray-12 font-weight-bold mb-2">
                {{ statusMainDescription(item.statusId) }}
              </div>
              <div class="color-gray-6 font-14 font-weight-normal">
                Estatus:
              </div>
              <div class="d-flex align-items-center">
                <em
                  class="fas fa-circle mr-2"
                  :class="`font-12 color-${getColorStatus(item.statusId)}`"
                />
                <div class="color-black font-16 font-weight-normal">
                  {{ item.statusName }}
                </div>
              </div>
            </div>
            <div class="col-md-9">
              <div class="row">
                <div class="col ml-5 ml-md-5 ml-sm-0">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Usuario:
                  </div>
                  <div class="color-black font-16 font-weight-normal">
                    {{ item.createUserName }}
                  </div>
                </div>
                <div
                  v-if="viewComments(item.comments)"
                  class="col ml-5 ml-md-5 ml-sm-0"
                >
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Descripción:
                  </div>
                  <div class="color-black font-16 font-weight-normal">
                    {{ item.comments }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
    <div
      v-if="pageCount > 1"
      class="d-flex justify-content-center align-items-center mt-3"
    >
      <action-button
        class="btn-see-more"
        i="fas fa-chevron-down"
        text="Ver más"
        variant="outline-success rounded-pill px-5"
        @click="onLoadMoreHandler"
      />
    </div>
  </div>
</template>

<script>
//Component Libs
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';

//Services
import { getProposalRequestStatusHistory as _getProposalRequestStatusHistory } from '@/modules/proposalProcess/api.js';

//Constants
import { proposalRequestStatus } from '@/utils/constants/proposalRequestStatus.js';
const DEFAULT_HISTORY_STATUS_PAGE_SIZE = 5;

export default {
  name: 'ContractStatusHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    proposalRequestId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    items: [],
    pageIndex: 1,
    pageSize: DEFAULT_HISTORY_STATUS_PAGE_SIZE,
    pageCount: 0,
  }),
  computed: {
    statusMainDescription() {
      return (statusId) =>
        statusId === proposalRequestStatus.Submitted
          ? 'Propuesta Sometida'
          : 'Cambio de Estatus';
    },
    getIconStatus() {
      return (statusId) => {
        return {
          [proposalRequestStatus.Submitted]: 'file-export',
          [proposalRequestStatus.Recommended]: 'retweet',
          [proposalRequestStatus.NotRecommended]: 'retweet',
        }[statusId];
      };
    },
    getColorStatus() {
      return (statusId) => {
        return {
          [proposalRequestStatus.Submitted]: 'yellow',
          [proposalRequestStatus.Recommended]: 'green-light',
          [proposalRequestStatus.NotRecommended]: 'brown',
        }[statusId];
      };
    },
    viewComments() {
      return (comments) => (!comments ? false : true);
    },
  },
  async mounted() {
    await this.getProposalRequestStatusHistory();
  },
  methods: {
    async getProposalRequestStatusHistory() {
      const result = (
        await _getProposalRequestStatusHistory(
          this.proposalRequestId,
          this.pageIndex,
          this.pageSize
        )
      ).data;

      this.items = result.data.filter((s) => s.id > 0);
      this.pageCount = result.pageCount;
    },
    async onLoadMoreHandler() {
      this.pageSize = this.pageSize + DEFAULT_HISTORY_STATUS_PAGE_SIZE;
      await this.getProposalRequestStatusHistory();
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

::v-deep .custom-time-line {
  div:first-child {
    margin-right: 0px !important;
    padding-right: 10px !important;
  }
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: map-get($colors, 'gray-2');
    color: map-get($colors, 'white');
    box-shadow: 0px 3px 6px #00000029;
  }
}
</style>
